import { styled } from '@mui/material'
import TextInput from '../../../../../../../../components/editors/input/TextInput'
import { colorPalette } from '../../../../../../../../style/colorPalette'

export const ConfigContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  padding: '16px',
})

export const SectionContent = styled('div')({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  overflowY: 'auto',
})

export const FormSection = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  marginBottom: '16px',
})

export const FormLabel = styled('label')({
  fontSize: '14px',
  fontWeight: 500,
  color: colorPalette.monotone[10],
  marginBottom: '4px',
})

export const ProjectPlanSelectWrapper = styled('div')({
  border: `1px solid ${colorPalette.monotone[2]}`,
  borderRadius: '4px',
  backgroundColor: colorPalette.monotone[0],
  height: '400px',
  overflow: 'auto',
})

export const TeamSelectWrapper = styled('div')({
  border: `1px solid ${colorPalette.monotone[2]}`,
  borderRadius: '4px',
  backgroundColor: colorPalette.monotone[0],
  width: '100%',
  height: '300px',
  overflow: 'auto',
})

export const EmptyConfigContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  backgroundColor: colorPalette.monotone[1],
})

export const EmptyConfigText = styled('span')({
  fontSize: '14px',
  color: colorPalette.monotone[4],
  textAlign: 'center',
})

export const PageTitleInput = styled(TextInput)({
  width: '50%',
  maxWidth: '400px',
  marginTop: '8px',
})

export const ToggleGroupWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  '& .MuiToggleButtonGroup-root': {
    backgroundColor: colorPalette.monotone[0],
  },
})

export const ErrorBanner = styled('div')({
  backgroundColor: colorPalette.pink[0],
  border: `1px solid ${colorPalette.pink[5]}`,
  borderRadius: '6px',
  padding: '12px 16px',
  marginBottom: '16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
})

export const ErrorMessages = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
})

export const ErrorMessage = styled('div')({
  fontSize: '13px',
  color: colorPalette.pink[5],
  lineHeight: '1.5',
})
